const USER_SET_USER_INFO = 'SET_USER_INFO';
const USER_SET_USER_PERMISSIONS = 'USER_SET_USER_PERMISSIONS';
const USER_SET_USER_ROLES = 'USER_SET_USER_ROLES';
const USER_SET_IS_RBICONNECT = 'USER_SET_IS_RBICONNECT';
const USER_SET_USER_BRANDS = 'USER_SET_USER_BRANDS';
const USER_SET_USER_ACCESS = 'USER_SET_USER_ACCESS';

export {
    USER_SET_USER_ACCESS,
    USER_SET_IS_RBICONNECT,
    USER_SET_USER_BRANDS,
    USER_SET_USER_INFO,
    USER_SET_USER_PERMISSIONS,
    USER_SET_USER_ROLES
}
